export default __webpack_public_path__ + "static/media/6.219a5d34.svg";